<script>

export default {
  name: 'autosave',
  data () {
    return {
      autoSaveTimer: null,
      hasChangeNotSaveYet: false,
      lastSaveTs: null,
      cahceLoadedNotification: null,
      cacheKey: 'cache-?'
    }
  },
  computed: {
    autoSaveHint () {
      if (!this.lastSaveTs) return ''
      if (!this.hasChangeNotSaveYet) return '所有變更已儲存至暫存'
      let s = Math.max(
        1,
        Math.ceil((new Date().getTime() - this.lastSaveTs) / 1000)
      )
      return `${s}秒前已暫存變更`
    }
  },
  methods: {
    autoSave () {
      if (!this.hasChangeNotSaveYet) return
      this.hasChangeNotSaveYet = false

      for (let key of this.languages) {
        this.form[key].Contents = JSON.stringify(this.form[key].contentJsonArr)
      }

      let cache = JSON.stringify(this.form)
      localStorage.setItem(this.cacheKey, cache)

      this.lastSaveTs = new Date().getTime()
    },
    clearCache () {
      localStorage.removeItem(this.cacheKey)
    },
    getCache () {
      return localStorage.getItem(this.cacheKey)
    },
    confirmLoadCache () {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          while (true) {
            if (window.confirm('偵測到先前有編輯到一半的紀錄\n是否載入暫存資料?')) {
              resolve('loaded')
              this.notifyCacheLoaded()
              break
            } else if (window.confirm('確定捨棄先前的暫存資料?')) {
              resolve('removed')
              localStorage.removeItem(this.cacheKey)
              break
            } else {
            // continue...
            }
          }
        }, 100)
      })
    },
    notifyCacheLoaded () {
      this.cahceLoadedNotification = this.$notify({
        message: '已載入暫存資料',
        duration: 0
      })
    }
  },
  created () {
    this.autoSaveTimer = setInterval(this.autoSave, 5000)
  },
  beforeDestroy () {
    clearInterval(this.autoSaveTimer)
    if (this.cahceLoadedNotification) this.cahceLoadedNotification.close()
    this.cahceLoadedNotification = null
  },
  watch: {
    form: {
      handler () {
        this.hasChangeNotSaveYet = true
      },
      deep: true
    }
  }
}
</script>
